import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { whatsappLink, COMPANY_NAME } from "@/lib/api";

export default function FloatingWhatsApp() {
  const [showTip, setShowTip] = useState(true);
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {showTip && (
        <div data-testid="whatsapp-tooltip" className="relative bg-white rounded-2xl shadow-xl border border-slate-200 p-4 max-w-[240px] animate-in fade-in slide-in-from-bottom-2">
          <button onClick={() => setShowTip(false)} className="absolute -top-2 -right-2 grid place-items-center h-6 w-6 rounded-full bg-slate-800 text-white"><X className="h-3.5 w-3.5" /></button>
          <p className="text-sm font-semibold text-slate-900">Dúvidas? 👋</p>
          <p className="text-xs text-slate-500 mt-1">Fale agora com um especialista pelo WhatsApp!</p>
        </div>
      )}
      <a
        href={whatsappLink(`Olá! Preciso de ajuda com os serviços da ${COMPANY_NAME}.`)}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        className="relative grid place-items-center h-16 w-16 rounded-full bg-emerald-500 text-white shadow-2xl shadow-emerald-600/40 hover:bg-emerald-600 hover:scale-105 transition-all"
      >
        <span className="pulse-ring absolute inset-0 rounded-full" />
        <MessageCircle className="h-8 w-8 relative" />
        <span className="absolute top-1 right-1 h-3 w-3 rounded-full bg-white border-2 border-emerald-500" />
      </a>
    </div>
  );
}
